// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3ME8Z","col-1-wrapper":"_eazl","stories":"_11W-L","col-2":"iXsGA","custom-story-card-2-stories":"_3mc3e","col-1":"_1I_6Y"};